import { useState } from "react"
import { useQuery } from "@tanstack/react-query"
import clsx from "clsx"
import GameScreenLayout from "@/components/GameScreenLayout"
import { getLeaderboard } from "@/api/gameApi"
import { LeaderboardScope } from "@/types/gameMeta"

export default function LeaderboardPage() {
  const [scope, setScope] = useState<LeaderboardScope>("city")

  const q = useQuery({
    queryKey: ["leaderboard", scope],
    queryFn: () => getLeaderboard(scope),
  })

  const data = q.data

  return (
    <GameScreenLayout title="Рейтинг" backTo="/play">
      <div className="mb-4 flex gap-2">
        {(["city", "global"] as const).map((s) => (
          <button
            key={s}
            type="button"
            onClick={() => setScope(s)}
            className={clsx(
              "flex-1 rounded-lg py-2 text-xs font-medium",
              scope === s
                ? "bg-guardians-accent text-guardians-bg"
                : "border border-white/20 text-guardians-muted"
            )}
          >
            {s === "city" ? "Город" : "Мир"}
          </button>
        ))}
      </div>

      {data?.cityName ? (
        <p className="mb-2 text-xs text-guardians-muted">{data.cityName}</p>
      ) : null}

      {data?.myRank != null ? (
        <p className="mb-3 text-sm">
          Ваше место: <span className="text-guardians-accent">#{data.myRank}</span>
          {data.myPts != null ? ` · ${data.myPts} очков` : ""}
        </p>
      ) : null}

      {q.isLoading ? (
        <p className="text-sm text-guardians-muted">Загрузка…</p>
      ) : (
        <ol className="space-y-1">
          {(data?.entries ?? []).map((entry) => (
            <li
              key={`${entry.rank}-${entry.publicGameCode ?? entry.nickname}`}
              className={clsx(
                "flex items-center gap-3 rounded-lg px-2 py-2",
                entry.isMe ? "bg-guardians-accent/15" : "hover:bg-white/5"
              )}
            >
              <span className="w-8 text-right text-sm text-guardians-muted">
                {entry.rank}
              </span>
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-medium">
                  {entry.nickname}
                  {entry.guildTag ? (
                    <span className="ml-1 text-xs text-guardians-muted">
                      [{entry.guildTag}]
                    </span>
                  ) : null}
                </p>
                {entry.cityName ? (
                  <p className="truncate text-[10px] text-guardians-muted">
                    {entry.cityName}
                  </p>
                ) : null}
              </div>
              <span className="text-sm tabular-nums text-guardians-accent">
                {entry.pts}
              </span>
            </li>
          ))}
        </ol>
      )}
    </GameScreenLayout>
  )
}
